import React from 'react';

import {Button, Icon, Text} from '@albert-io/atomic';
import type {IconProp} from '@albert-io/atomic/atoms/Icon/Icon.react';

interface Props {
  copy: string;
  icon?: IconProp;
  subtitle?: string;
  onRetry?: () => void;
}

export default function TabEmptyState({copy, icon, subtitle, onRetry}: Props) {
  'use memo';

  return (
    <div className='gap-x2 rounded-x1 border-primary p-x4 flex flex-col items-center justify-center border'>
      {icon && (
        <div className='h-x8 w-x8 background-bold p-x1-half flex items-center justify-center rounded-full'>
          <Icon className='text-xxl' color='tertiary' icon={icon} />
        </div>
      )}
      <Text color='secondary'>{copy}</Text>
      {subtitle && (
        <Text color='secondary' className='max-w-[48ch] text-center text-balance'>
          {subtitle}
        </Text>
      )}
      {onRetry && (
        <Button color='secondary' variant='outlined' size='s' roundness='pill' onClick={onRetry}>
          Try Again
        </Button>
      )}
    </div>
  );
}
